<template>
  <div class="language-switcher">
    <el-dropdown @command="handleLanguageChange" placement="bottom">
      <el-button type="link" class="language-btn">
        <svg class="language-icon" viewBox="0 0 24 24" width="16" height="16">
          <path fill="currentColor" d="M12.87,15.07L10.33,12.56L10.36,12.53C12.1,10.59 13.34,8.36 14.07,6H17V4H10V2H8V4H1V6H12.17C11.5,7.92 10.44,9.75 9,11.35C8.07,10.32 7.3,9.19 6.69,8H4.69C5.42,9.63 6.42,11.17 7.67,12.56L2.58,17.58L4,19L9,14L12.11,17.11L12.87,15.07M18.5,10H16.5L12,22H14L15.12,19H19.87L21,22H23L18.5,10M15.88,17L17.5,12.67L19.12,17H15.88Z"/>
        </svg>
        <span class="language-text">{{ currentLanguageLabel }}</span>
        <el-icon class="el-icon--right">
          <arrow-down />
        </el-icon>
      </el-button>
      <template #dropdown>
        <el-dropdown-menu>
          <el-dropdown-item 
            v-for="lang in availableLanguages" 
            :key="lang.code"
            :command="lang.code"
            :class="{ 'is-active': currentLocale === lang.code }"
          >
            <span class="flag">{{ lang.flag }}</span>
            <span class="lang-name">{{ lang.name }}</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </template>
    </el-dropdown>
  </div>
</template>

<script>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { ArrowDown } from '@element-plus/icons-vue'

export default {
  name: 'LanguageSwitcher',
  components: {
    ArrowDown
  },
  setup() {
    const { locale } = useI18n()
    
    const availableLanguages = [
      {
        code: 'zh-CN',
        name: '简体中文',
        flag: '🇨🇳'
      },
      {
        code: 'en-US',
        name: 'English',
        flag: '🇺🇸'
      }
    ]
    
    const currentLocale = computed(() => locale.value)
    
    const currentLanguageLabel = computed(() => {
      const current = availableLanguages.find(lang => lang.code === locale.value)
      return current ? current.name : '语言'
    })
    
    const handleLanguageChange = (langCode) => {
      locale.value = langCode
      localStorage.setItem('locale', langCode)
      
      // 刷新页面以确保所有组件都使用新语言
      // 在实际项目中，你可能不需要刷新页面
      window.location.reload()
    }
    
    return {
      availableLanguages,
      currentLocale,
      currentLanguageLabel,
      handleLanguageChange
    }
  }
}
</script>

<style scoped>
.language-switcher {
  display: inline-block;
}

.language-btn {
  display: flex !important;
  align-items: center;
  padding: 8px 12px;
  color: var(--el-text-color-primary);
  font-size: 14px;
}

.language-btn:hover {
  color: var(--el-color-primary);
}

.language-icon {
  margin-right: 6px;
  flex-shrink: 0;
}

.language-text {
  margin-right: 4px;
}

.flag {
  margin-right: 8px;
  font-size: 16px;
}

.lang-name {
  font-size: 14px;
}

.el-dropdown-menu__item.is-active {
  color: var(--el-color-primary);
  font-weight: 500;
}

.el-dropdown-menu__item.is-active .flag {
  filter: brightness(1.2);
}
</style>